// (A) 중립 Radio API — antd 미접촉. (B) PlainRadioGroup/PlainRadio 에 위임.
// antd Radio.Group / Radio 복합을 OmwRadioGroup + OmwRadio 로 분리.
import type { CSSProperties, ReactNode } from 'react'
import { PlainRadioGroup, PlainRadio } from '../_impl/PlainRadio'

/** 실측: string('day'/'left') 과 number(0/1) 값 모두 사용. */
export type OmwRadioValue = string | number

export interface OmwRadioGroupProps {
  value?: OmwRadioValue
  defaultValue?: OmwRadioValue
  onChange?: (value: OmwRadioValue) => void
  name?: string
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export interface OmwRadioProps {
  value: OmwRadioValue
  disabled?: boolean
  children?: ReactNode
}

export function OmwRadioGroup(props: OmwRadioGroupProps) {
  return <PlainRadioGroup {...props} />
}

export function OmwRadio(props: OmwRadioProps) {
  return <PlainRadio {...props} />
}
